import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import classes from './Styles/TextChartCard.css';
import Spinner from '../UI/Spinner/Spinner';

import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import Tooltip from '@material-ui/core/Tooltip';
import { formatNumber } from '../../assets/shared/formatNumber';
import IndDeshabilitado from '../../assets/images/IndicadorDeshabilitado-Texto.png';
import SinResultado from '../../assets/images/SinResultados-Texto.png';
import { storageMonedaSigno } from '../../assets/shared/sessionData';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import FilterListIcon from '@material-ui/icons/FilterList';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { IconButton } from '@material-ui/core';

const TextChart = (props) => {
  const {
    // EXISTENTES
    bigAmount,
    smallAmount,
    border,
    disabled,
    comparacionInvertida,
    bigAmountTooltip,
    bigAmoutClickRedirect,
    cursorPointer,
    bigCurrency,
    smallAmountTooltip,
    smallAmoutClickRedirect,
    smallCurrency,
    porcentaje,
    diferencia,
    title,
    onFiltersClick,
    customDisabledImage,
    loading,
    colorSpinner,
    imgSinDatos,
    sinAccesoPorPlan,
    onBodyClick,
    currencySimbol,
    // NUEVOS (opcionales y compatibles)
    bgColor, // <- color de fondo del card
    bigAmountDisplay, // <- texto a mostrar en grande (no afecta la flecha)
    customSmallText // <- texto inferior completo (sin “: 100”)
  } = props;

  const [hover, setHover] = useState(false);

  let percIncrease = Math.round(((bigAmount / smallAmount - 1) * 100 + Number.EPSILON) * 100) / 100;
  const diferenciaLocal = (bigAmount - smallAmount).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });

  if (isNaN(percIncrease)) percIncrease = 0;

  const cssClasses = [classes.TextChartCard];
  if (border && !disabled && (bigAmount >= smallAmount || (bigAmount >= 0 && smallAmount === undefined))) {
    comparacionInvertida ? cssClasses.push(classes.BorderRed) : cssClasses.push(classes.BorderGreen);
  }
  if (border && !disabled && (bigAmount < smallAmount || (bigAmount < 0 && smallAmount === undefined))) {
    comparacionInvertida ? cssClasses.push(classes.BorderGreen) : cssClasses.push(classes.BorderRed);
  }

  const labelOnClickHandler = (redirectPath) => {
    if (redirectPath) window.open(redirectPath);
  };

  // --------- TEXTO GRANDE (ahora admite override) ----------
  const renderBigDisplay = () => {
    if (bigAmountDisplay !== undefined && bigAmountDisplay !== null) {
      return String(bigAmountDisplay);
    }
    if (typeof bigAmount === 'number') {
      if (bigCurrency) {
        const simb = currencySimbol ?? storageMonedaSigno();
        return `${simb} ${formatNumber(disabled ? 0 : bigAmount)}`;
      }
      return `${bigAmount}`;
    }
    return bigAmount; // string u otro nodo
  };

  const textoGrande = bigAmount !== undefined && (
    <Tooltip style={{ textAlign: 'left', marginTop: '5px' }} title={bigAmountTooltip || ''}>
      <div
        style={{
          fontWeight: 'bold',
          marginBottom: '5px',
          marginTop: '0px',
          cursor: bigAmoutClickRedirect || cursorPointer ? 'pointer' : 'default'
        }}
        className={classes.TextoGrande}
        onClick={() => labelOnClickHandler(bigAmoutClickRedirect)}
      >
        {renderBigDisplay()}
      </div>
    </Tooltip>
  );

  // --------- TEXTO CHICO (ahora admite custom completo) ----------
  const textoChico = (smallAmount !== undefined || smallAmountTooltip || customSmallText) && (
    <Tooltip title={customSmallText ? '' : smallAmountTooltip || ''}>
      <div
        style={{
          marginTop: '0px',
          cursor: smallAmoutClickRedirect || cursorPointer ? 'pointer' : 'default',
          paddingRight: '10px'
        }}
        onClick={() => labelOnClickHandler(smallAmoutClickRedirect)}
        className={classes.TextoChico}
      >
        {customSmallText
          ? customSmallText
          : smallAmount !== undefined
          ? `${smallAmountTooltip}: ${
              smallCurrency ? `${storageMonedaSigno()} ${formatNumber(disabled ? 0 : smallAmount)}` : `${smallAmount}`
            }`
          : smallAmountTooltip}
      </div>
    </Tooltip>
  );

  const flechaUp = (
    <TrendingUpIcon
      fontSize="large"
      style={border ? { color: 'white' } : { color: comparacionInvertida ? 'red' : 'green' }}
    />
  );
  const flechaDown = (
    <TrendingDownIcon
      fontSize="large"
      style={border ? { color: 'white' } : { color: comparacionInvertida ? 'green' : 'red' }}
    />
  );
  const flechaFlat = <TrendingFlatIcon fontSize="large" style={border && { color: 'white' }} />;

  const mostrarTextoComparacion =
    (porcentaje || diferencia) && smallAmount !== undefined && bigAmount !== undefined && smallAmount !== 0;

  let iconoSubidaBajada = null;
  let diferenciaOPorcentaje = null;
  if (mostrarTextoComparacion) {
    iconoSubidaBajada = percIncrease === 0 ? flechaFlat : percIncrease > 0 ? flechaUp : flechaDown;
    diferenciaOPorcentaje = diferencia ? diferenciaLocal : `${Math.abs(percIncrease)}%`;
  }

  return (
    <div
      className={cssClasses.join(' ')}
      onMouseEnter={() => onBodyClick && setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        backgroundColor: bgColor ?? (!border && hover && onBodyClick ? '#f5f5f5' : undefined),
        boxShadow: hover && onBodyClick ? '0 4px 8px rgba(0,0,0,0.15)' : '0 2px 4px rgba(0,0,0,0.1)',
        cursor: onBodyClick ? 'pointer' : 'default',
        userSelect: 'none',
        transition: 'all 0.2s ease-in-out'
      }}
    >
      <div className={classes.CardTitle}>
        <p style={{ fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' }}>{title}</p>
        {onFiltersClick && !disabled && (
          <Tooltip title="Ver filtros del indicador">
            <IconButton size="small" onClick={() => onFiltersClick()}>
              <FilterListIcon style={{ color: border && 'white' }} fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </div>

      {disabled ? (
        <img
          alt="Indicador Inhabilitado"
          className={classes.IndDeshabilitado}
          src={customDisabledImage || IndDeshabilitado}
        />
      ) : loading ? (
        <Spinner size="small" color={colorSpinner} />
      ) : imgSinDatos ? (
        sinAccesoPorPlan ? (
          <div className={classes.SinAccesoPlan}>
            <LockOutlinedIcon style={{ fontSize: 40 }} />
            <span>Indicador no disponible para este plan.</span>
          </div>
        ) : (
          <img src={SinResultado} width="auto" alt="Indicador sin resultado" className={classes.IndDeshabilitado} />
        )
      ) : (
        <div
          style={{ display: 'flex', flexFlow: 'row', cursor: onBodyClick ? 'pointer' : 'default' }}
          onClick={() => onBodyClick && onBodyClick()}
        >
          <div className={classes.textos} style={{ width: '100%' }}>
            {textoGrande}
            {textoChico}
          </div>
          {mostrarTextoComparacion && (
            <div className={classes.IconoDiferenciaOPorcentaje}>
              {iconoSubidaBajada}
              {diferenciaOPorcentaje}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default withRouter(TextChart);
